module.exports = __webpack_public_path__ + "static/media/bindQQ2.25d449c5.png";